/** TanStack Query keys of the onboarding chat, so a mutation can set or invalidate exactly what it changed. */
export const onboardingKeys = {
  all: ['onboarding'] as const,
  snapshot: (sessionId: string) => ['onboarding', 'snapshot', sessionId] as const,
  brandGuide: (sessionId: string) => ['onboarding', 'brand-guide', sessionId] as const,
  adAccounts: (sessionId: string) => ['onboarding', 'ad-accounts', sessionId] as const,
  /** Every platform's analysis of a session (a prefix of `adAnalysis`). */
  adAnalysisAll: (sessionId: string) => ['onboarding', 'ad-analysis', sessionId] as const,
  adAnalysis: (sessionId: string, platform: string) => ['onboarding', 'ad-analysis', sessionId, platform] as const,
  competitors: (sessionId: string) => ['onboarding', 'competitors', sessionId] as const,
};
